import { sortDates } from "../sortDates";
import { getBookingDate } from "../getBookingDate";

export const formatLOSChartData = (
  bookedBookings,
  cancelledBookings,
  dataMode
) => {
  const bookedTotalsByDate = bookedBookings.reduce((acc, booking) => {
    const date = getBookingDate(booking, dataMode);
    if (!acc[date]) acc[date] = { totalDays: 0, bookingCount: 0 };
    acc[date].totalDays += booking.totaldays;
    acc[date].bookingCount += 1;
    return acc;
  }, {});
  const cancelledTotalsByDate = cancelledBookings.reduce((acc, booking) => {
    const date = getBookingDate(booking, dataMode);
    if (!acc[date]) acc[date] = { totalDays: 0, bookingCount: 0 };
    acc[date].totalDays += booking.totaldays;
    acc[date].bookingCount += 1;
    return acc;
  }, {});

  const labels = sortDates([
    ...new Set([
      ...Object.keys(bookedTotalsByDate),
      ...Object.keys(cancelledTotalsByDate),
    ]),
  ]);
  const bookedData = labels.map((date) => {
    const { totalDays, bookingCount } = bookedTotalsByDate[date] || {
      totalDays: 0,
      bookingCount: 0,
    };
    return bookingCount > 0 ? Number((totalDays / bookingCount).toFixed(2)) : 0;
  });
  const cancelledData = labels.map((date) => {
    const { totalDays, bookingCount } = cancelledTotalsByDate[date] || {
      totalDays: 0,
      bookingCount: 0,
    };
    return bookingCount > 0 ? Number((totalDays / bookingCount).toFixed(2)) : 0;
  });

  return {
    labels,
    datasets: [
      {
        label: "Booked",
        data: bookedData,
        backgroundColor: "rgba(255, 235, 59, 0.6)",
        borderColor: "rgba(255, 235, 59, 1)",
        borderWidth: 1,
      },
      {
        label: "Cancelled",
        data: cancelledData,
        backgroundColor: "rgba(255, 99, 132, 0.4)",
        borderColor: "rgba(255, 99, 132, 1)",
        borderWidth: 1,
      },
    ],
  };
};
